export const text = {
  xxs: `12px`,
  xs: `14px`,
  sm: `16px`,
  base: `18px`,
  lg: `20px`,
  xl1: `24px`,
  xl2: `30px`,
  xl3: `36px`,
  xl4: `48px`,
  xl5: `60px`,
  xl6: `64px`
}

export const icon = {
  xs: `12px`,
  sm: `16px`,
  md: `24px`,
  lg: `32px`,
  xl: `48px`,
}

export const container = {
  sm: `640px`,
  md: `768px`,
  lg: `1024px`,
  xl: `1280px`,
}

export const spacing = {
  1: `0.25rem`,
  2: `0.5rem`,
  3: `0.75rem`,
  4: `1rem`,
  5: `1.25rem`,
  6: `1.5rem`,
  8: `2rem`,
  10: `2.5rem`,
  12: `3rem`,
  16: `4rem`,
  20: `5rem`,
  24: `6rem`,
  32: `8rem`,
  40: `10rem`,
  48: `12rem`,
  56: `14rem`,
  64: `16rem`,
}




